import { Box, Button, Typography, Tooltip } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import { useTheme } from '../constants/themeProvider';
import { ColorsConstant } from "./colorConstant";

const OverlayButton = (props) => {
    const { title, onClick, classStyleHeading, classStyleText, disabled, disabledTooltip } = props;
    const theme = useTheme();

    const button = (
                <Button style={{background: disabled ? '#a0a0a0' : theme?.primaryColor, borderColor: ColorsConstant.headerColor, opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer', pointerEvents: disabled ? 'none' : 'auto'}} className={classStyleHeading || ''} onClick={onClick} disabled={Boolean(disabled)}>
                        <Box className={classStyleText || ''}>
            <Typography variant="inherit" style={{color: theme?.primaryFontText}}>
              {title}
            </Typography>
            </Box>
        </Button>
    );

    if (disabled && disabledTooltip) {
        return (
            <Tooltip title={disabledTooltip} arrow placement="bottom">
                <span style={{ cursor: 'not-allowed' }}>{button}</span>
            </Tooltip>
        );
    }

    return button;
};

OverlayButton.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onClick: PropTypes.func,
    classStyleHeading: PropTypes.string,
    classStyleText: PropTypes.string,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.string,
};

export default OverlayButton;